import { isEmpty } from 'lodash';
import { instantpayBalanceEnquiry, instantpayCashwithdrawal, instantpayCheckAepsStatus, instantpayMerchantLoginFingerprient, instantpayMiniStatement } from '../../utils/api';
import { parseString } from 'xml2js';
export const initialControls = {
	transactionType: '',
	aadharNumber: '',
	amount: '',
	bank: '',
	mobileNumber: '',
};

export const checkLoginStatus = (setAlert, setLoading, setAepsStatus) => {
	setLoading(true);
	instantpayCheckAepsStatus().then((resp) => {
		setLoading(false);
		if (resp?.success) {
		} else {
			if (resp?.errorCodeList.length > 0) {
				setAlert({ type: 'error', msg: resp?.errorCodeList[0] });
				setAepsStatus('SELECT_DEVICE_FOR_LOGIN');
			} else {
				setAlert({ type: 'error', msg: resp?.msg });
				setAepsStatus('');
			}
		}
	});
};

let testMantraPort = 1;
export function CaptureFingerData(
	type,
	deviceType,
	aepsStatus,
	setBankDataResp,
	overLayers,
	setOverLayer,
	setControls,
	setFingerprintLoader,
	controls,
	setAepsStatus,
	setAlert,
	setLoading,
	geolocation,
	closePop
) {
	var url = '';
	var PIDOPTS =
		'<PidOptions ver="1.0"> <Opts fCount="1" fType="2" iCount="0" pCount="0" format="0" pidVer="2.0" timeout="20000" otp="" posh="UNKNOWN" env="P" wadh="" /> <Demo></Demo><CustOpts> <Param name="ValidationKey" value="" /> </CustOpts> </PidOptions>';

	setLoading(true);
	if (deviceType === 'Morpho') {
		if (testMantraPort === 1) {
			url = 'https://127.0.0.1:11100/capture';
		} else {
			url = 'http://127.0.0.1:11100/capture';
		}
	} else if (deviceType === 'Mantra') {
		const preUrl = localStorage.getItem('MantraRdUrll');
		if (preUrl) {
			url = preUrl;
		} else {
		if (testMantraPort === 1) {
					url = `https://127.0.0.1:11100/rd/capture`;
				} else if (testMantraPort === 2) {
					url = 'https://127.0.0.1:11101/rd/capture';
				} else if (testMantraPort === 3) {
					url = 'https://127.0.0.1:8005/rd/capture';
				}else if (testMantraPort === 4) {
					url = `http://127.0.0.1:11100/rd/capture`;
					} else if (testMantraPort === 5) {
							url = 'http://127.0.0.1:11101/rd/capture';
					}else if(testMantraPort === 6) {
						url = 'https://127.0.0.1:8005/rd/capture';
					}
		}
	} else if (deviceType === 'Tatvik') {
		url = 'https://127.0.0.1:11100/rd/capture';
	}

	var xhr;
	setFingerprintLoader(true);
	xhr = new XMLHttpRequest();
	xhr.open('CAPTURE', url, true);
	xhr.setRequestHeader('Content-Type', 'text/xml');
	xhr.setRequestHeader('Accept', 'text/xml');

	xhr.onreadystatechange = async function () {
		if (xhr.readyState === 4) {
			var status = xhr.status;

			if (status === 200) {
				var test1 = xhr.responseText;
				var test2 = test1.search('errCode');
				var test6 = getPosition(test1, '"', 2);
				var test4 = test2 + 9;
				var test5 = test1.slice(test4, test6);

				convertXmlToJs(xhr.responseText).then((result) => {
					const error = result?.PidData?.Resp[0].$;
					if (deviceType === 'Mantra') {
						if (testMantraPort === 1) {
							const url = `https://127.0.0.1:11100/rd/capture`;
							localStorage.setItem('MantraRdUrl', url);
						} else if (testMantraPort === 2) {
							const url = 'https://127.0.0.1:11101/rd/capture';
							localStorage.setItem('MantraRdUrl', url);
						} else if (testMantraPort === 3) {
							const url = 'https://127.0.0.1:8005/rd/capture';
							localStorage.setItem('MantraRdUrl', url);
						}
					}
					setFingerprintLoader(false);
					if (Number(error.errCode) != 0) {
						setLoading(false);
						setAlert({ type: 'error', msg: error.errInfo });

						return;
					} else {
						setAlert({ type: 'success', msg: 'FingerPrint Captured Successfully' });
						setLoading(false);

						const qscore = result?.PidData?.Resp[0]?.$.qScore;
						let abc = qscore.replace('\n', '');
						let resp_ = result?.PidData?.Resp[0]?.$;
						resp_ = { ...resp_, qScore: abc };
						if (isEmpty(resp_?.iCount)) {
							resp_.iCount = '0';
						}
						if (isEmpty(resp_?.pgCount)) {
							resp_.pgCount = '';
						}
						if (isEmpty(resp_?.pTimeout)) {
							resp_.pTimeout = '';
						}
						if (isEmpty(resp_?.pCount)) {
							resp_.pCount = '0';
						}

						const fingerPrirntData = {
							errInfo: result?.PidData?.Resp[0]?.$?.errInfo,
							errorCode: result?.PidData?.Resp[0]?.$?.errCode,
							message: 'FingerPrint Scanned Successfully',
							pidDataJson: {
								PidData: {
									Data: {
										content: result?.PidData?.Data[0]?._,
										type: result?.PidData?.Data[0]?.$?.type,
									},
									DeviceInfo: {
										additional_info: {
											Param: [
												{
													name: 'serial_number',
													value: result?.PidData?.DeviceInfo[0]?.additional_info[0]?.Param[0]?.$?.name,
												},
												{
													name: result?.PidData?.DeviceInfo[0]?.additional_info[0]?.Param[0]?.$?.name,
													value: result?.PidData?.DeviceInfo[0]?.additional_info[0]?.Param[0]?.$?.name,
												},
											],
										},
										dc: result?.PidData?.DeviceInfo[0]?.$?.dc,
										dpId: result?.PidData?.DeviceInfo[0]?.$?.dpId,
										mc: result?.PidData?.DeviceInfo[0]?.$?.mc,
										mi: result?.PidData?.DeviceInfo[0]?.$?.mi,
										rdsId: result?.PidData?.DeviceInfo[0]?.$?.rdsId,
										rdsVer: result?.PidData?.DeviceInfo[0]?.$?.rdsVer,
									},
									Hmac: result?.PidData?.Hmac[0],
									Resp: resp_,
									Skey: {
										ci: result?.PidData?.Skey[0]?.$.ci,
										content: result?.PidData?.Skey[0]?._,
									},
								},
							},
							pidDataXML: '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' + xhr?.responseText,
						};

						if (type === 'customer') {
							setLoading(true);
							const param = {
								mobileNumber: controls.mobileNumber,
								bankIIN: controls.bank,
								adhaarNumber: controls.aadharNumber,
								amount: 0,
								pid_xml_base64e: '',
								externalRef: '',
								latitude: geolocation.latitude.toFixed(4),
								longitude: geolocation.longitude.toFixed(4),
								pid_xml_base64e: fingerPrirntData,
							};
							if (controls.transactionType === 'Withdrawal') {
								param.amount = controls.amount;
								instantpayCashwithdrawal(param).then((res) => {
									setLoading(false);
									if (res?.data) {
										setOverLayer(true);
										overLayers(true);
										setBankDataResp(res.data);
									} else {
										closePop();
										if (res?.errorCodeList.length > 0) {
											setAlert({ type: 'error', msg: res?.errorCodeList[0], place: 'globle' });
										} else {
											setAlert({ type: 'error', msg: res?.msg, place: 'globle' });
										}
									}
								});
							}

							if (controls.transactionType === 'enquiry') {
								instantpayBalanceEnquiry(param).then((res) => {
									setLoading(false);
									if (res?.data) {
										setControls({ ...initialControls });
										setOverLayer(true);
										overLayers(true);
										setBankDataResp(res.data);
									} else {
										closePop();
										if (res?.errorCodeList.length > 0) {
											setAlert({ type: 'error', msg: res?.errorCodeList[0], place: 'globle' });
										} else {
											setAlert({ type: 'error', msg: res?.msg, place: 'globle' });
										}
									}
								});
							}

							if (controls.transactionType === 'statement') {
								instantpayMiniStatement(param).then((res) => {
									setLoading(false);
									if (res?.data) {
										setControls({ ...initialControls });
										setOverLayer(true);
										overLayers(true);
										setBankDataResp(res.data);
									} else {
										closePop();
										if (res?.errorCodeList.length > 0) {
											setAlert({ type: 'error', msg: res?.errorCodeList[0], place: 'globle' });
										} else {
											setAlert({ type: 'error', msg: res?.msg, place: 'globle' });
										}
									}
								});
							}
						} else {
							merchantFingerPrient(fingerPrirntData, setAlert, setAepsStatus, setLoading, aepsStatus, closePop,geolocation);
						}
					}
				});
			} else {
				setLoading(false);
				setFingerprintLoader(false);
			}
		}
	};

	xhr.onerror = function () {
		if (deviceType === 'Mantra') {
			setLoading(false);
			if (testMantraPort < 6) {
				testMantraPort = testMantraPort + 1;
				CaptureFingerData(
					type,
					deviceType,
					aepsStatus,
					setBankDataResp,
					overLayers,
					setOverLayer,
					setControls,
					setFingerprintLoader,
					controls,
					setAepsStatus,
					setAlert,
					setLoading,
					geolocation,
					closePop
				);
			}
		}
		if (deviceType === 'Morpho') {
			setLoading(false);
			if (testMantraPort < 2) {
				testMantraPort = testMantraPort + 1;
				CaptureFingerData(
					type,
					deviceType,
					aepsStatus,
					setBankDataResp,
					overLayers,
					setOverLayer,
					setControls,
					setFingerprintLoader,
					controls,
					setAepsStatus,
					setAlert,
					setLoading,
					geolocation,
					closePop
				);
			}
		}
	};
	xhr.send(PIDOPTS);
}

const merchantFingerPrient = (fingerPrirntData, setAlert, setAepsStatus, setLoading, aepsStatus, closePop,geolocation) => {
	const data = {
		biometricData: fingerPrirntData,
		latitude: geolocation.latitude.toFixed(4),
	   longitude: geolocation.longitude.toFixed(4),
		
	};
	setLoading(true);
	instantpayMerchantLoginFingerprient(data).then((resp) => {
		setLoading(false);
		if (resp?.success) {
			setAlert({ type: 'success', msg: 'Merchant Login successfull You can continue', place: 'globle' });
			if (aepsStatus === 'CAPTUR_FOR_LOGIN') {
				setAepsStatus('TRANSACTION_SCREEN');
			} else {
				setAepsStatus('CAPTUR_CUSTOMER');
			}
		} else {
			if (aepsStatus !== 'CAPTUR_FOR_LOGIN') {
				closePop();
			}
			if (resp?.errorCodeList.length > 0) {
				setAlert({ type: 'error', msg: resp?.errorCodeList[0], place: 'globle' });
			} else {
				setAlert({ type: 'error', msg: resp?.msg, place: 'globle' });
			}
		}
	});
};

function convertXmlToJs(xmlData) {
	return new Promise((resolve, reject) => {
		parseString(xmlData, (err, result) => {
			if (err) {
				reject(err);
			} else {
				resolve(result);
			}
		});
	});
}

function getPosition(string, subString, index) {
	return string.split(subString, index).join(subString).length;
}
